import SellerIBAConfigurationPage from "./sellerIBAConfigurationPage";
export default SellerIBAConfigurationPage;
